import { useQuery } from "@tanstack/react-query";
import { LocationsKeys } from "./locations.keys";
import { useApi } from "../../../api/ApiProvider";

const STALE_TIME = 10 * 60 * 1000; // 10 min – Stammdaten ändern sich selten

export const useAdminBusinesses = () => {
  const { adminEntities } = useApi();
  return useQuery({
    queryKey: LocationsKeys.businesses.all(),
    queryFn: () => adminEntities.adminGetAllBusinesses(),
    staleTime: STALE_TIME,
    meta: { errorMessage: "Firmen konnten nicht geladen werden" },
  });
};

export const useAdminAccounts = () => {
  const { adminEntities } = useApi();
  return useQuery({
    queryKey: LocationsKeys.accounts.all(),
    queryFn: () => adminEntities.adminGetAllAccounts(),
    staleTime: STALE_TIME,
    meta: { errorMessage: "Mandanten konnten nicht geladen werden" },
  });
};

export const useAccountLogo = (accountId: string | null, enabled = true) => {
  const { adminEntities } = useApi();
  return useQuery({
    queryKey: LocationsKeys.accounts.logo(accountId ?? ""),
    queryFn: () => adminEntities.adminGetAccountLogo(accountId!),
    enabled: !!accountId && enabled,
    staleTime: STALE_TIME,
    retry: false,
    meta: { errorMessage: "Logo konnte nicht geladen werden" },
  });
};

export const useAdminLocations = () => {
  const { adminEntities } = useApi();
  return useQuery({
    queryKey: LocationsKeys.locations.all(),
    queryFn: () => adminEntities.adminGetAllLocations(),
    staleTime: STALE_TIME,
    meta: { errorMessage: "Standorte konnten nicht geladen werden" },
  });
};
